module.exports = Object.freeze({
    PORTAL_ADMIN : 1,
    PORTAL_USER : 2,

    REF_SUPER_ADMIN: 100,
    REF_ADMIN: 101,
    REF_DATA_ENTRY: 102,

    TD_SUPER_ADMIN: 200,
    //User Permissions are required for all below roles
    TD_ADMIN: 201,
    TD_TAKEDOWN_ADMIN: 202,
    TD_BUILDER: 203,
    TD_ASSET_MANAGER: 204,
    TD_READ_ONLY: 205
});



// WEBPACK FOOTER //
// ./client/app/_helpers/userRoles.js